<div class="movie-info">
    <div class="card">
      <div class="header">
        @for (lang of manga.langs; track lang) {
          <span class="lang-tag">{{ lang }}</span>
        }
        <span class="series-tag">Series</span>
      </div>
      <h2 class="title">{{ manga.title }}</h2>
      <div class="tags">
        @for (tag of manga.tags; track tag) {
          <span class="tag {{ tag.toLowerCase() }}">{{ tag }}</span>
        }
      </div>
      <div class="stats">
        <span>👁️ {{ manga.stats.views  | shortenNumber }}</span>
        <span>⭐ {{ manga.stats.stars  | shortenNumber }}</span>
        <span>💬 {{ manga.stats.comments  | shortenNumber }}</span>
      </div>
      
      <p class="description" [class.hidden]="!showDetails">
        {{ manga.description }}
      </p>

      <div class="author" [class.hidden]="!showDetails">
        <img class="author-photo" [src]="author.photo" alt="Author" />
        <span class="name">{{author.name}}</span>
        <button class="follow-btn">⭐</button>
      </div>
      <div class="social-buttons" [class.hidden]="!showDetails">
        <button class="reddit">Reddit</button>
        <button class="facebook">Facebook</button>
        <button class="twitter">Twitter</button>
      </div>
      <div class="meta" [class.hidden]="!showDetails">
        <div class="metadata">📅 Published: {{ manga.published }}</div>
        <div class="metadata">📝 Updated: {{ manga.updated }}</div>
      </div>
      <a href="#" class="report-link">Report</a>
      <button class="details-btn" (click)="toggleDetails()">
        {{ showDetails ? 'Ocultar detalles ⮝' : 'Ver detalles ⮟' }}
      </button>
  </div>
</div>